import { render, staticRenderFns } from "./post_blog.vue?vue&type=template&id=5199c195&scoped=true&"
import script from "./post_blog.vue?vue&type=script&lang=js&"
export * from "./post_blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199c195",
  null
  
)

export default component.exports